import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import CSS from "csstype";
import Layout from "components/global/Layout";
// global state
import { useRecoilState } from "recoil";
import { navbarColorState, pageLoadedState } from "../state/atoms";

const FourOhFour = () => {
    // Update Navbar Color
    const [navbarColor, setNavbarColor] = useRecoilState(navbarColorState);
    setNavbarColor("light");
    const [pageLoaded, setPageLoaded] = useRecoilState(pageLoadedState);

    setPageLoaded(true); // Disable loading screen for 404s

    return (
        <Layout title="Error 404: Page Not Found">
            <main className="page errorPage">
                <div className="wrapper">
                    <h1>404</h1>
                    <p>Sorry, the page you requested could not be found.</p>
                    <a className="btn narrow" href="/">
                        Go to Homepage
                    </a>
                </div>
            </main>
        </Layout>
    );
};

export default FourOhFour;
